export default "__VITE_ASSET__d508076b__"